var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWireless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x31__x2C_5",
    enableBackground: "new 0 0 36 36",
    height: 512,
    viewBox: "0 0 36 36",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m27.623 4.167c-6.917 0-11.667-3.583-15-3.583s-10.333 1.916-10.333 17.249 9.417 17.583 13.083 17.583c17.167.001 24.5-31.249 12.25-31.249z",
    fill: "#efefef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4afc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.856 2.82h2v1h-2z",
    transform: "matrix(.707 -.707 .707 .707 6.983 23.498)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.467 1.967h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 6.097 20.648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.533 6.033h1v2h-1z",
    transform: "matrix(.707 -.707 .707 .707 4.412 24.716)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9 12c0-.69.56-1.25 1.25-1.25h-2.25c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h2.25c-.69 0-1.25-.56-1.25-1.25z",
    fill: "#d5dbe1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.357 15.034-.035-.177c-.187-.935-1.008-1.608-1.961-1.608h-2.25c.953 0 1.774.673 1.961 1.608l.035.177c.374 1.87 2.016 3.216 3.922 3.216h1.942c.052 0 .102-.012.154-.014-1.839-.071-3.404-1.383-3.768-3.202z",
    fill: "#d5dbe1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24 29c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.056 26.1-1.076-1.045.522-.538c.93-.958 2.175-1.497 3.505-1.517 1.34.018 2.592.482 3.549 1.412l.538.522-1.044 1.076-.539-.522c-.67-.65-1.553-1-2.482-.988-.929.014-1.8.391-2.451 1.062z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m18.821 23.309-1.129-.987.494-.564c1.521-1.74 3.57-2.719 5.77-2.756 2.224-.041 4.276.875 5.845 2.566l.51.55-1.1 1.02-.51-.55c-1.275-1.375-2.955-2.135-4.72-2.086-1.771.029-3.427.826-4.666 2.242z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m18.39 19h-1.36c-2.259 0-4.217-1.608-4.656-3.824l-.034-.144c-.123-.608-.638-1.032-1.23-1.032h-3.11c-1.103 0-2-.897-2-2s.897-2 2-2h20c1.103 0 2 .897 2 2s-.897 2-2 2h-3.11c-.592 0-1.107.424-1.225 1.009l-.045.193c-.15.714-.462 1.395-.901 1.952l-1.179-.928c.296-.377.509-.844.616-1.351l.044-.188c.254-1.258 1.387-2.188 2.69-2.188h3.11c.276 0 .5-.225.5-.5s-.224-.5-.5-.5h-20c-.276 0-.5.225-.5.5s.224.5.5.5h3.11c1.303 0 2.436.931 2.695 2.212l.035.146c.306 1.542 1.645 2.642 3.19 2.642h1.36z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m7 7h6v1.5h-6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m8 23.5h3.5v1.5h-3.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m9.25 7.75h1.5v2.75h-1.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m23 7h6v1.5h-6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m25.25 7.75h1.5v2.75h-1.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m10.5 24.25h-1.5v-4c0-2.344 1.907-4.25 4.25-4.25h.5v1.5h-.5c-1.517 0-2.75 1.233-2.75 2.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireless);
export default __webpack_public_path__ + "static/media/wireless.7d6e76442bba3952a78d35382b6ff9ba.svg";
export { ForwardRef as ReactComponent };